import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import {ConfigService} from "../config.service";

@Component({
  selector: 'chat-info-menu',
  templateUrl: './chat-info-menu.component.html',
  styleUrls: ['./chat-info-menu.component.scss'],
  standalone: false
})
export class ChatInfoMenuComponent implements OnInit {
  swirlVersion: string | null = '';
  chatInfoMenuEnabled: boolean = true;

  constructor(private authService: AuthService, private configService: ConfigService) { }

  ngOnInit(): void {
    this.swirlVersion = this.authService.getSwirlVersion();

    this.configService.getConfig('default').subscribe(configResponse => {
      if (configResponse) {
        if (configResponse.chatInfoMenuEnabled !== undefined) {
          this.chatInfoMenuEnabled = configResponse.chatInfoMenuEnabled;
        }
      }
    });
  }
}
